import React from 'react'

const Manual_tipo_de_pago_cloudbeds = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
     <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
     Cloudbeds - Tipo de Pago
     </h2>
     <p className="text-lg text-gray-700 mb-6">
        Esta guía proporciona un proceso paso a paso para integrar Cloudbeds como
        método de pago en su sistema, garantizando un seguimiento y generación de
        informes de pagos fluidos. Siguiendo estas instrucciones, podrá configurar y
        personalizar eficazmente su integración de pagos, optimizando así las
        operaciones de su negocio. Es esencial para quienes buscan optimizar sus
        procesos de pago con Cloudbeds, lo que la convierte en un recurso valioso para
        optimizar la eficiencia y la claridad.
     </p>
     <iframe
          src="https://scribehow.com/embed/Cloudbeds__Tipo_de_Pago__eFuAwnUVQGySdaPVBxgX3A?as=scrollable"
          className="scribe-iframe-cloudbeds-1"
          width="100%"
          height="4500"
          allowFullScreen
          style={{
            aspectRatio: '1 / 1',
            border: 0,
            minHeight: '480px'
          }}
        ></iframe>
   </div>
   </div>
  )
}

export default Manual_tipo_de_pago_cloudbeds